export default {
  login: {
    welcomeMsg: "Karibu! ",
    info: "Weka kitambulisho chako.",
    forgot: "Umesahau nywila?",
    btn: "Ingia",
    unableToLogin: "Haiwezi Kuingia",
  },
  forgot: {
    info_l1:
      "Tafadhali ingiza anwani ya barua pepe inayohusishwa na akaunti yako. ",
    info_l2:
      "Tafadhali weka nambari yako ya simu inayohusishwa na akaunti yako. ",
    info_l3:
      "Tafadhali chagua mojawapo ya chaguo zifuatazo ili kupokea maelekezo ya jinsi ya kuweka upya nenosiri lako",
    forgotQ: "Umesahau nenosiri yako?",
    loginNow: "Ingia Sasa",
    resetSucc: "Nenosiri lako limewekwa upya",
    resetSucc_l2:
      "Sasa unaweza kutumia nenosiri lako jipya kuingia katika akaunti yako.",
    entPsw: "Tafadhali weka nenosiri lako jipya.",
    resetPsw: "Weka upya Nenosiri lako",
    resendOTP: "Tuma tena OTP",
    enterCorrectOTP: "Tafadhali weka OTP sahihi.",
    enterOTP: "Tafadhali ingiza OTP iliyopokelewa kwa barua pepe/simu.",
    backToLoginPage: "Rudi kwenye ukurasa wa Kuingia",
    recieveCodeFalse: " Sikupokea nambari ya kuthibitisha",

    "changePassword": "Badilisha Nenosiri",
    "changePasswordSubtitle": "Tafadhali weka nenosiri lako jipya hapa chini",
    "oldPassword": "Nenosiri la Zamani",
    "newPassword": "Nenosiri Jipya",
    "confirmPassword": "Thibitisha Nenosiri",
    "resetPassword": "Weka Upya Nenosiri",
    "resetPasswordSubtitle": "Tafadhali weka nenosiri lako jipya hapa chini",
    "resetPasswordBtn": "Weka Upya Nenosiri",
    "backToLogin": "Rudi kwenye Kuingia",
    "oldPasswordRequired": "Nenosiri la zamani linahitajika",
    "passwordResetSuccess": "Nenosiri limewekwa upya kwa mafanikio",
    "passwordResetFailed": "Imeshindikana kuweka upya nenosiri",
    "errorOccurred": "Hitilafu imetokea"
  },
  permissions: {
    savePermissions: "HIFADHI VIBALI",
    moduleName: "Jina la Moduli",
    view: "Tazama",
    create: "Unda",
    update: "Sasisha",
    delete: "Futa",
    permissionsUpdated: "Ruhusa Zimesasishwa",
    permissionsNotUpdated: "Ruhusa hazijasasishwa",
    selectMembership: "Chagua Uanachama",
    noPermMsg:
      "Tafadhali chagua aina ya uanachama kwa kutumia 'Aina ya Uanachama' kunjuzi hapo juu ili kuona ruhusa zako",
    selectRoleMsg: "Tafadhali chagua Jukumu hapo juu ili kuonyesha ruhusa",
  },
  activationKey: {
    enterActivationKey:
      "Tafadhali weka ufunguo wa kuwezesha kusajili mtumiaji mpya",
    countryRequired: "Nchi Inahitajika",
    activationKeyRequired: "Ufunguo wa Amilisho Unahitajika",
    activationKey: "Ufunguo wa Uanzishaji",
    activationKeyLimit: "Ufunguo wa Amilisho Ni Mfupi Sana",
    membershipRoleFilterDesc: "Chuja Mpango wa Uanachama kwa Wajibu",
    email: "Barua pepe",
    filterBy: "Chuja Kwa",
    membershipRoleFilter: "Kichujio cha Wajibu wa Uanachama",
    appointSalesManager: "Teua Meneja wa Uuzaji",
    appointManager: "TEUA MENEJA",
    salesManAppSuccess: "MENEJA MAUZO ATEULIWA KWA MAFANIKIO",
    uploadData: "PAKIA CSV YA DATA ILIYOGAIWA",
    uploadUserData: "Tafadhali pakia faili ya data ya mtumiaji",
    downloadCsv: "Pakua sampuli ya faili ya .csv ili kufuata muundo",
    downloadSample: "Pakua sampuli ya faili",
    dragDrop: "Buruta na uangushe au",
    browse: "kuvinjari",
    yourFile: "faili yako",
    pdfSupport: "Alleen PDF-bestanden worden ondersteund.",
    pleaseWait: "Tafadhali subiri",
    note: "Notitie",
    incorectFileType: "Aina ya faili isiyo sahihi",
    somethingWentWrong: "Hitilafu fulani imetokea",
    fileUploadedSuccess: "Faili Imepakiwa",
    countRecords: "Hesabu Rekodi",
    sendNow: "TUMA SASA",
    fileName: "jina la faili",
    assignActKey: "Inakabidhi Vifunguo vya Uwezeshaji",
    actKeyAssSucc: "Vifunguo vya kuwezesha vimekabidhiwa",
    viewActKey: "TAZAMA VIFUNGUO VYA kuwezesha",
    actKeyQuota: "Sehemu ya Vifunguo vya Uanzishaji",
    genActKey: "Funguo za Uanzishaji Zilizozalishwa",
    remActKey: "Vifunguo Vilivyobaki vya Uamilisho",
    penUsed: "Vifunguo Vinavyosubiri na Vilivyotumika",
    activationKeyAss: "Vifunguo vya Amilisho Vimekabidhiwa",
    activationKeyUnass: "Vifunguo vya Amilisho Havijakabidhiwa",
    keysAct: "Vifunguo Vimewashwa",
    uploadedFiles: "Faili Zilizopakiwa",
    generateActKey: "TENGENEZA VIFUNGUO VYA kuwezesha",
    showData: "Onyesha Data",
    noDataFound: "Hakuna Tarehe Iliyopatikana",
    pleaseGenKey:
      'Tafadhali tengeneza vitufe vya kuwezesha kwa kutumia "Tengeneza Vifunguo vya Uanzishaji" ',
    noActKey: "Bado hakuna vitufe vya kuwezesha vilivyotolewa",
    buttonAbv: "kitufe hapo juu",
    numberOfActKey: "Idadi ya Vifunguo vya Uwezeshaji",
    membershipRole: "Jukumu la Uanachama",
    membershipPlan: "Mpango wa Uanachama",
    comments: "Maoni",
    genKeys: "TENGENEZA FUNGUO",
    keysNum: "Nambari ya Vifunguo",
    phoneNumber: "Nambari ya simu",
    keysStatus: "Hali ya Vifunguo",
    ActivationKeysList: "Orodha ya Vifunguo vya Uanzishaji",
    back: "NYUMA",
    usingActKeys: 'kwa kutumia "Tengeneza Vifunguo vya Uanzishaji" ',
    pleaseGenActKeyss: "Tafadhali tengeneza vitufe vya kuwezesha",
    clearAllFilters: "FUTA VICHUJI ZOTE",
    salesManager: "Meneja Mauzo",
    clearAll: "FUTA YOTE",
    generatedBy: "Imetolewa Na",
    numberOfKeys: "Idadi ya Funguo",
    action: "Kitendo",
    viewAllUplFiles: "TAZAMA FAILI ZOTE ZILIZOPAKIWA",
    bulkUploadUsers: "WATUMIAJI WENGI WA KUPAKIA",
    noActivationKeyFound: "Hakuna Vifunguo vya Uwezeshaji Vilivyopatikana",
    pleaseCreateAdminRole: "Tafadhali unda jukumu la msimamizi kwa kutumia",
    btnCreateAdmin: "kitufe cha 'Unda Jukumu la Msimamizi' hapo juu",
    donwloadAsCsv: "Pakua kama CSV",
    donwloadAsPdf: "Pakua kama PDF",
    assignSalesManager: "Weka Meneja Mauzo",
    shareViaEmail: "Shiriki kupitia Barua pepe",
    sendEmail: "KUTUMA BARUA PEPE",
    emailSend: "BARUA PEPE IMETUMA KWA MAFANIKIO",
    donwload: "Pakua",
    deleteFile: "Futa Faili",
    invalidFileData: "Data ya ufunguo wa kuwezesha kwenye faili si sahihi",
  },
  profileSetting: {
    profileAuthSettings: "Mipangilio ya Uthibitishaji wa Wasifu",
    changeSettings: "BADILISHA MIPANGILIO",
    loginLogoutSettings: "Mipangilio ya Kuingia/Kuacha",
    autoLogout: "Ingia kiotomatiki",
    unsuccAtmp: "Jaribio la Kuingia Bila Mafanikio",
    unsuccLoginLock: "Kipindi cha Kufungia nje hakijafaulu",
    pswCrisetup: "Uwekaji wa Vigezo vya Nenosiri",
    pswLength: "Urefu wa nenosiri",
    noOfUniquePsw: "Idadi ya manenosiri ya kipekee inahitajika ",
    maxPswAge: "Umri wa juu wa nenosiri",
    AccRangeOfchars: "Aina zinazokubalika za wahusika",
    upperCase: "Kesi ya Juu",
    lowerCase: "Kesi ya Chini",
    numbers: "Nambari",
    specialChars: "Wahusika maalum",
    settingsUpdated: "Mipangilio Imesasishwa",
    settingsNotUpdated: "Mipangilio Haijasasishwa",
    organization: "Shirika",
    organizationLogo: "Nembo ya shirika",
    organizationSplash: "Shirika Splash Screen",
    addAnother: "Ongeza Mwingine",
    alert: "Tahadhari",
    alertAdmin: "Tahadhari kwa msimamizi",
    alertCountry: "Nchi",
    alertCountryInfo: "Nchi ambayo utapata tahadhari",
    alertCrop: "Mazao",
    alertCropInfo: "Mazao ambayo utapata tahadhari",
    alertFarmer: "Tahadhari kwa Mkulima",
    alertFor: "Chagua anayepokea tahadhari",
    alertMaximum: "Kiasi cha juu",
    alertMaximumInfo:
      "Kiasi cha juu kinachoruhusiwa baada ya hapo utapata tahadhari",
    alertRegion: "Mkoa",
    alertRegionInfo: "Mkoa wa nchi iliyochaguliwa ambayo utapata tahadhari",
    browse: "Vinjari",
    crop: "Mazao",
    cropsHarvestAlert: "Tahadhari ya Kuvuna Mazao",
    defaultOrganizationOTPForSignUp: "OTP chaguomsingi kwa Usajili wa Shirika",
    defaultOtpOrganization: "Shirika la OTP chaguomsingi kwa Usajili",
    dragAndDropOr: "Buruta na Uachilie au Vinjari",
    generateOtp: "Tengeneza OTP",
    maxAllowed: "Kiwango cha Juu Kinachoruhusiwa / Ha / Mwaka",
    maxProduction: "Uzalishaji wa Juu Zaidi / Hekta / Mwaka",
    maxProductionError: "Lazima uingize Uzalishaji wa Juu Zaidi",
    organizationSplash1: "Splash ya Shirika",
    organizationSplashScreen: "Skirini ya Splash ya Shirika",
    otp: "OTP",
    passwordReuse: "Kutumia tena Nenosiri",
    save: "Hifadhi",
    selectCountry: "Chagua Nchi",
    selectCountryInfo: "Chagua eneo la kijiografia linalotumika kwa tathmini.",
    selectCountryError: "Tafadhali chagua nchi kwanza",
    selectCrop: "Chagua Mazao",
    selectCropError: "Tafadhali chagua mazao kwanza",
    unitError: "Tafadhali weka uzalishaji wa juu na kitengo",
    whoreceivedthealert: "Anayepokea Tahadhari",
  },
  adminRoles: {
    adminRoles: "Majukumu ya Msimamizi",
    roleName: "Jina la jukumu",
    description: "Maelezo",
    viewPermissions: "Tazama Ruhusa",
    createAdminRole: "TENGENEZA NAFASI YA ADMIN",
    enterDesHere: "Weka maelezo yako hapa",
    deleteRole: "Futa Majukumu",
    deleteMsg: "Je, una uhakika unataka kufuta jukumu?",
    roleReq: "Jina la jukumu linahitajika",
    roleLimit: "Jina la jukumu lazima liwe chini ya herufi 15",
    desReq: "Maelezo inahitajika",
    desLimit: "Maelezo lazima yawe na vibambo 40 au chini ya hapo",
    roleSuccess: "Jukumu limeundwa",
    editAdminRole: "Badilisha Jukumu la Msimamizi",
    roleUpdated: "Jukumu Limesasishwa",
    noRole: "Hakuna Majukumu ya Msimamizi Yaliyopatikana",
    noRoleMsg:
      "Tafadhali unda jukumu la msimamizi kwa kutumia kitufe cha 'Unda Jukumu la Msimamizi' hapo juu",
    roleType: "Aina ya Jukumu",
  },
  roleRequest: {
    roleRequest: "Ombi la Wajibu",
    userRole: "Wajibu wa Mtumiaji",
    approve: "Idhinisha",
    reject: "Kataa",
    username: "jina la mtumiaji",
    email: "Barua pepe",
    phone: "Simu",
    roleAssigned: "Jukumu Limetolewa",
    roleRequested: "Jukumu Limeombwa",
    requestedDate: "Tarehe Iliyoomba",
    updateRoleRequest: "Sasisha Ombi la Wajibu",
    message: "Ujumbe",
    update: "Sasisha",
  },
  userslist: {
    createNewUser: "Unda Mtumiaji Mpya",
    chooseCreateType: "Tafadhali chagua mojawapo ya chaguo zifuatazo:",
    addNewUser: "Ongeza Mtumiaji Mpya",
    editUser: "Badilisha Mtumiaji",
    addNewAdmin: "Ongeza Mtumiaji Msimamizi",
    userLoading: "Inapakia Watumiaji... Tafadhali subiri",
    noUser: "HAKUNA MTUMIAJI ANAYEPATIKANA",
    extendVal: "ONGEZA UHAKIKA",
    extendReason: "Sababu ya Kuongeza",
    extendReasonMsg: "Bainisha sababu ya kuongeza muda wa uanachama",
    exportAsCSV: "USAFIRISHA KWA KAMA CSV",
    membershipType: "Aina ya Uanachama",
    membershipValidity: "Uhalali wa Uanachama",
    regionState: "Mkoa/Jimbo",
    cityTown: "Mji/Mji",
    clearAll: "FUTA YOTE",
    search: "TAFUTA",
    familyTribe: "Ingiza kabila la familia yako",
    enterWebsite: "Ingiza tovuti",
    registrationDate: "Tarehe ya Usajili",
    single: "Mtu mmoja",
    multiple: "Nyingi",
    user: "Mtumiaji",
    addRole: "Ongeza Wajibu",
    convertUser: "Badilisha Mtumiaji kuwa Msimamizi",
    existingUser: "Chagua kutoka kwa Mtumiaji aliyepo",
    newUser: "Tengeneza Mtumiaji Mpya wa Msimamizi",
    users: "Watumiaji",
    role: "Jukumu",
    department: "Idara",
  },
  addEdituser: {
    facilityPicture: "Picha ya kituo",
    firstNameRequired: "Jina la Kwanza linahitajika",
    firstNameOllyAlpha: "Jina la Kwanza linaweza kuwa na alfabeti pekee",
    firstNameLimit: "Jina la Kwanza lazima liwe chini ya herufi 50",
    lastNameRequired: "Jina la Mwisho linahitajika",
    lastNameOllyAlpha: "Jina la Mwisho linaweza kuwa na alfabeti pekee",
    lastNameLimit: "Jina la Ukoo lazima liwe chini ya herufi 50",
    emailReuired: "Barua pepe inahitajika",
    emailInvalid: "Umbizo la barua pepe si sahihi.",
    mobileRequired: "Nambari ya simu inahitajika",
    mobileLimit: "Nambari ya simu inapaswa kuwa chini ya tarakimu 15",
    invalidMobile: "Umbizo batili la nambari ya simu.",
    emailExistAlready: "L'utente esiste già con questa email.",
    mobileExistAlready: "L'utente esiste già con questo numero di cellulare.",
    pswRequired: "Nenosiri linahitajika",
    deptRequired: "Idara inahitajika",
    roleRequired: "Jukumu linahitajika",
    countryRequired: "Msimbo wa Nchi unahitajika",
    userUpdated: "Mtumiaji Alisasishwa",
    userNotUpdated: "Mtumiaji Hajasasishwa",
    activateAct: "Amilisha Akaunti",
    deactivateAct: "Zima Akaunti",
    userActivated: "Mtumiaji Amilishwa",
    userDeactivated: "Mtumiaji Amezimwa",
    deactivateUser: "Zima Mtumiaji",
    deactivateMsg: "Je, una uhakika unataka kubadilisha hali ya mtumiaji.",
    userAdded: "Mtumiaji Ameongezwa",
    userNotAdded: "Mtumiaji Hajaongezwa",
    editAppUser: "Badilisha Mtumiaji wa Programu",
    validityUpTo: "Uhalali Hadi",
    department: "Idara",
    departmentAdded: "Idara Imeongezwa",
    departmentEdited: "Idara Imehaririwa",
    departmentNameRequired: "Jina la Idara Linahitajika",
    departmentRequired: "Shamba la Idara Linahitajika",
    editDepartment: "Hariri Idara",
    failedToAdd: "Imeshindwa Kuongeza",
    noDepartment: "Hakuna Idara",
    roleAdded: "Nafasi Imeongezwa",
    roleEdited: "Nafasi Imehaririwa",
    roleNameLimit: "Jina la Nafasi Lazima Liwe Chini ya Herufi 100",
    roleNameOnlyAlpha: "Jina la Nafasi Linaweza Kuwa na Herufi Pekee",
    eoriNumberRequired: "Nambari ya EORI inahitajika",
    eoriIsNumber: "EORI lazima iwe nambari",
    addNewSupplier: "Ongeza Msambazaji Mpya",
    addNewProducer: "Ongeza Mtengenezaji Mpya",
    addNewOperator: "Ongeza Mwajiriwa Mpya",
    eoriNumber: "Nambari ya EORI",
  },
  membership: {
    remainingDays: "Idadi ya Siku Zilizoongezwa",
    type: "Aina ya Uanachama",
    validity: "Uhalali wa Uanachama",
    validityLength: {
      custom: "Desturi",
      expired: "Muda wake umeisha",
      oneTo8Months: "Miezi 1-8",
      lessThan1Month: "Chini ya mwezi 1",
      moreThan1Month: "Zaidi ya mwaka 1",
      sixTo12Months: "Miezi 6-12",
    },
  },
  membershipplanSection: {
    defaultPlan: " MPANGO MSINGI",
    planType: "AINA YA MPANGO",
    planDuration: "Muda wa Mpango",
    planFee: "Ada ya Mpango",
    satelliteReport: "RIPOTI YA SATELLITE",
    advanceReport: "RIPOTI YA ADVANCE",
    addMembership: "ONGEZA UANACHAMA",
    addMembershipPlan: "Ongeza Mpango wa Uanachama",
    editMembershipPlan: "Hariri Mpango wa Uanachama",
    accessSetelite: "Ufikiaji wa Ripoti za Satellite (Seti ya ripoti 5)",
    accessAdvanceReport: "Upatikanaji wa Ripoti za Kina",
    memPlanReq: "Mpango wa Uanachama unahitajika",
    memPlanReqLimit: "Mpango wa uanachama lazima uwe chini ya vibambo 20",
    SatelliteReq: "Ripoti ya Setilaiti inahitajika",
    advancedReportReq: "Ripoti ya Kina inahitajika",
    durationReq: "Muda wa Uanachama unahitajika",
    feeReq: "Ada ya Uanachama inahitajika",
    cantLesThenZero: "Haiwezi kuwa chini ya 0",
    roleReq: "Jukumu la mtumiaji linahitajika",
    accessToDeforestationReport:
      "Ufikiaji wa Ripoti za Ukataji Miti (Kwa Kila Mtumiaji)",
    advancedFarmLevelReports: "Ripoti za Kina za Ngazi ya Shamba",
    basicFarmLevelReports: "Ripoti za Msingi za Ngazi ya Shamba",
    enterprise: "Kampuni",
    largeAreaReports: "Ripoti za Eneo Kubwa",
    noOfFarms: "Idadi ya Mashamba",
    noOfUsersAllowed: "Idadi ya Watumiaji Walioidhinishwa",
    perFarm: "Kwa Kila Shamba",
    perUser: "Kwa Kila Mtumiaji",
    satelliteReportPackage: "Paketi ya Ripoti ya Satellite",
    selectPlan: "Chagua Mpango",
  },
  statusItems: {
    closed: "Imefungwa",
    open: "Fungua",
  },
  orderByItems: {
    all: "Wote",
    dateAscending: "Tarehe ya Kupanda",
    dateDescending: "Tarehe ya Kushuka",
    dueDate: "Tarehe ya kukamilisha",
    high: "Juu",
    low: "Chini",
    medium: "Kati",
  },
  record: {
    appVersion: "Toleo la App",
    createdAt: "Imeundwa",
    harvestingDate: "Tarehe ya Kuvuna",
    id: "Kitambulisho",
    module: "Moduli",
    noOfTrees: "Idadi ya Miti",
    reason: "Sababu",
    userId: "Kitambulisho cha Mtumiaji",
  },
  ownershipTypes: {
    EXW: "EXW (Katika Kiwanda)",
    FCA: "FCA (Mtoa Huduma Huru)",
    CPT: "CPT (Usafirishaji Uliolipiwa Hadi)",
    CIP: "CIP (Usafirishaji na Bima Iliyolipiwa Hadi)",
    DAP: "DAP (Imewasilishwa Mahali)",
    DPU: "DPU (Imewasilishwa Mahali Iliyopakuliwa)",
    DDP: "DDP (Imewasilishwa na Ushuru Uliolipiwa)",
    FAS: "FAS (Huru Kando ya Meli)",
    FOB: "FOB (Huru Juu ya Meli)",
    CFR: "CFR (Gharama na Usafirishaji)",
    CIF: "CIF (Gharama, Bima na Usafirishaji)",
  },
};
